module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pager",
    style: ({
      'height': _vm.detail ? '100vh' : '90vh'
    })
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "position": "-webkit-sticky"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 20px"
    }
  }, [_c('div', {
    staticClass: "flex-y-bottom"
  }, [_c('div', {
    staticClass: "bo-logo flex-grow-0"
  }, [_c('img', {
    attrs: {
      "src": _vm.serviceUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bo-title flex-grow-1"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "white-space": "nowrap",
      "overflow": "hidden",
      "text-overflow": "ellipsis"
    }
  }, [_vm._v(_vm._s(_vm.eu1.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.sampleSpec ? _vm.sampleSpec + ' / ' : '') + "\n                " + _vm._s(_vm.sampleType ? _vm.sampleType + ' / ' : '') + "\n                " + _vm._s(_vm.experimentalTotalNum ? _vm.experimentalTotalNum + '个样本' : '') + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }, [_c('span', {
    staticClass: "real-price"
  }, [_vm._v("￥" + _vm._s(_vm.emkt.formatPrice(_vm.formalQuotePrice)))]), _vm._v(" "), (_vm.formalQuotePrice !== _vm.standardPrice) ? _c('span', {
    staticClass: "sale-price"
  }, [_c('s', [_vm._v("￥" + _vm._s(_vm.emkt.formatPrice(_vm.standardPrice)))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow-1 right"
  }, [_c('span', {
    staticClass: "deliver-text"
  }, [_vm._v("预计交付周期：")]), _vm._v(" "), _c('span', {
    staticClass: "deliver-value"
  }, [_vm._v(_vm._s(_vm.serviceWorkDaysSolution ? _vm.serviceWorkDaysSolution.workdays : 15) + "个工作日")])])])]), _vm._v(" "), (_vm.promotion && _vm.promotion.name) ? _c('div', {
    staticClass: "advertising-banner"
  }, [_vm._v(_vm._s(_vm.promotion.name))]) : _vm._e(), _vm._v(" "), (!_vm.detail) ? _c('div', {
    staticClass: "step-wrapper"
  }, [_c('van-steps', {
    attrs: {
      "active": _vm.stepNo,
      "active-color": "#5878FA",
      "inactive-color": "#979797",
      "finish-icon": "checked",
      "active-icon": "checked",
      "inactive-icon": "circle"
    }
  }, [_c('van-step', [_vm._v("样本类型")]), _vm._v(" "), _c('van-step', [_vm._v("其他参数")]), _vm._v(" "), _c('van-step', [_vm._v("确认方案")])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', [_c('van-popup', {
    style: ({
      width: '98%',
      height: '40%'
    }),
    attrs: {
      "closeable": "",
      "round": "",
      "close-icon": "close"
    },
    on: {
      "close": _vm.closeSampleCategoryPopup
    },
    model: {
      value: (_vm.showSampleCategory),
      callback: function($$v) {
        _vm.showSampleCategory = $$v
      },
      expression: "showSampleCategory"
    }
  }, [_c('div', {
    staticClass: "pop-title"
  }, [_c('span', [_vm._v("样本分类")])]), _vm._v(" "), _c('div', {
    staticClass: "item-title"
  }, [_c('span', [_vm._v("样本类型")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row sample-wrapper"
  }, _vm._l((_vm.sampleCategoryOptArr), function(item, index) {
    return (item.dictValue !== '-') ? _c('div', {
      key: index,
      staticClass: "flex-grow-1"
    }, [_c('div', {
      class: _vm.sampleCategoryItemChecked[index] ? 'radioTagChecked' : 'radioTag',
      on: {
        "click": function($event) {
          return _vm.pickSampleCategory(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.dictValue) + "\n              ")])]) : _vm._e()
  }), 0), _vm._v(" "), _vm._l((_vm.sampleCategoryOptArr), function(category, k) {
    return _c('div', {
      key: k
    }, [(_vm.sampleCategoryItemChecked[k]) ? _c('div', [_c('div', {
      staticClass: "item-title"
    }, [_c('span', [_vm._v(_vm._s(_vm.sampleCategoryOptArr[k].extraValue))])]), _vm._v(" "), _c('div', {
      staticClass: "flex-row sample-wrapper"
    }, _vm._l((_vm.sampleSubCategoryOptArr), function(item, index) {
      return (category.dictKey === item.parentId) ? _c('div', {
        key: index,
        staticClass: "flex-grow-1"
      }, [_c('div', {
        class: _vm.subCategoryChecked[index] ? 'radioTagChecked' : 'radioTag',
        on: {
          "click": function($event) {
            return _vm.pickSubCategory(index)
          }
        }
      }, [_vm._v("\n                    " + _vm._s(item.dictValue) + "\n                  ")])]) : _vm._e()
    }), 0)]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "pop-button-wrap"
  }, [_c('div', {
    staticClass: "pop-button",
    on: {
      "click": _vm.closeSampleCategoryPopup
    }
  }, [_c('span', [_vm._v("确定")])])])], 2)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "80vh",
      "overflow": "auto"
    }
  }, [(_vm.stepNo === 0) ? _c('div', [_c('van-form', [_c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v(" 样本信息")]), _vm._v(" "), _c('div', {
    staticClass: "cell-group-wrap"
  }, [_c('van-cell', {
    attrs: {
      "center": "",
      "title": "是否具有传染性",
      "title-class": "cell-title"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('van-switch', {
          attrs: {
            "size": "24"
          },
          model: {
            value: (_vm.infectionChecked),
            callback: function($$v) {
              _vm.infectionChecked = $$v
            },
            expression: "infectionChecked"
          }
        })]
      },
      proxy: true
    }], null, false, 1607973655)
  }), _vm._v(" "), (_vm.infectionChecked) ? _c('div', {
    staticClass: "warning-info"
  }, [_c('span', [_vm._v("注意：根据相关法律规定，传染性生物样本需要严格管控，\n              吉凯目前不具备处理传染性样本的实验条件，请您务必保证提供的生物样本为非传染性样本；\n              若一旦发现您提供的生物样本具有传染性，吉凯将保留追究相应的刑事和民事责任的权利。\n            ")])]) : _vm._e(), _vm._v(" "), (!_vm.infectionChecked) ? _c('van-cell', [_c('van-row', {
    attrs: {
      "gutter": "2"
    }
  }, [_c('van-col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v("样本物种")]), _vm._v(" "), _vm._l((_vm.sampleSpecOptArr), function(item, index) {
    return _c('van-col', {
      key: index,
      attrs: {
        "span": "4"
      }
    }, [_c('div', {
      class: _vm.sampleSpecItemChecked[index] ? 'radioTagChecked' : 'radioTag',
      on: {
        "click": function($event) {
          return _vm.pickSampleSpec(index)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(item.chnName) + "\n                    ")])])
  }), _vm._v(" "), _c('van-col', {
    attrs: {
      "span": "2"
    }
  })], 2), _vm._v(" "), (_vm.showOtherSampleSpecInput) ? _c('van-field', {
    ref: "otherSampleSpecNameField",
    attrs: {
      "placeholder": "请输入其他物种名称",
      "rules": [{
        validator: _vm.validateOtherSampleSpecName,
        message: '请输入其他物种名称',
        trigger: 'onBlur'
      }]
    },
    on: {
      "change": _vm.handleOtherSpecNameChanged
    },
    model: {
      value: (_vm.otherSampleSpecName),
      callback: function($$v) {
        _vm.otherSampleSpecName = $$v
      },
      expression: "otherSampleSpecName"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.infectionChecked) ? _c('van-field', {
    ref: "diseaseDirectionField",
    attrs: {
      "label-class": "form-label",
      "is-link": "",
      "readonly": "",
      "label": "疾病方向",
      "placeholder": "请选择疾病方向",
      "rules": [{
        validator: _vm.validateDiseaseDirection,
        message: '请选择疾病方向',
        trigger: 'onBlur'
      }]
    },
    on: {
      "click": function($event) {
        _vm.showDiseaseDirectionPicker = true
      }
    },
    model: {
      value: (_vm.diseaseDirectionName),
      callback: function($$v) {
        _vm.diseaseDirectionName = $$v
      },
      expression: "diseaseDirectionName"
    }
  }) : _vm._e(), _vm._v(" "), _c('van-popup', {
    attrs: {
      "round": "",
      "position": "bottom"
    },
    model: {
      value: (_vm.showDiseaseDirectionPicker),
      callback: function($$v) {
        _vm.showDiseaseDirectionPicker = $$v
      },
      expression: "showDiseaseDirectionPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.diseaseDirectionOpts,
      "value-key": "diseaseName"
    },
    on: {
      "cancel": _vm.onCancelDiseaseDirection,
      "confirm": _vm.onConfirmDiseaseDirection
    }
  })], 1), _vm._v(" "), (!_vm.infectionChecked) ? _c('van-field', {
    ref: "sampleCategoryField",
    attrs: {
      "label-class": "form-label",
      "is-link": "",
      "readonly": "",
      "label": "样本分类",
      "placeholder": "请选择样本分类",
      "rules": [{
        validator: _vm.validateSampleCategory,
        message: '请选择样本分类',
        trigger: 'onBlur'
      }]
    },
    on: {
      "click": _vm.showSampleCategoryPopup
    },
    model: {
      value: (_vm.sampleCategory.label),
      callback: function($$v) {
        _vm.$set(_vm.sampleCategory, "label", $$v)
      },
      expression: "sampleCategory.label"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.infectionChecked) ? _c('van-field', {
    ref: "sampleTypeField",
    attrs: {
      "label-class": "form-label",
      "label": "样本类型",
      "placeholder": "填写示例：癌或癌旁样本",
      "rules": [{
        validator: _vm.validateSampleType,
        message: '请填写样本类型',
        trigger: 'onBlur'
      }]
    },
    on: {
      "change": _vm.handleChangeSampleType,
      "blur": _vm.reSetPageScroll,
      "focus": _vm.reSetPageScroll
    },
    model: {
      value: (_vm.sampleType),
      callback: function($$v) {
        _vm.sampleType = $$v
      },
      expression: "sampleType"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bizValidateMsg !== ''),
      expression: "bizValidateMsg !== ''"
    }],
    staticClass: "warning-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.bizValidateMsg) + "\n            ")])])], 1), _vm._v(" "), (!_vm.infectionChecked) ? _c('div', {
    staticStyle: {
      "height": "30px",
      "background-color": "#fafafa"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.infectionChecked) ? _c('div', {
    staticClass: "cell-group-wrap"
  }, [_c('van-cell', {
    attrs: {
      "center": "",
      "title": "剩余样本返回"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('van-switch', {
          attrs: {
            "size": "24"
          },
          on: {
            "click": _vm.handleChangeReturnMaterial
          },
          model: {
            value: (_vm.returnMaterialChecked),
            callback: function($$v) {
              _vm.returnMaterialChecked = $$v
            },
            expression: "returnMaterialChecked"
          }
        })]
      },
      proxy: true
    }], null, false, 3092763397)
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cell-group-wrap"
  }, [(!_vm.infectionChecked) ? _c('van-cell-group', {
    attrs: {
      "title": "实验组及样本数"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0 20px",
      "font-size": "14px"
    }
  }, [_vm._l((_vm.experimentalGroup), function(experimental, index) {
    return _c('div', {
      staticStyle: {
        "padding": "20px 0"
      }
    }, [_c('span', {
      staticClass: "cancel-default-style"
    }, [_c('van-field', {
      staticStyle: {
        "float": "left",
        "width": "100px"
      },
      attrs: {
        "placeholder": "未命名",
        "input-align": "right"
      },
      on: {
        "blur": function($event) {
          return _vm.handleChangeGroupName(index)
        }
      },
      model: {
        value: (experimental.label),
        callback: function($$v) {
          _vm.$set(experimental, "label", $$v)
        },
        expression: "experimental.label"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "icon-font emkt-icon-xiugai",
      staticStyle: {
        "color": "#5878fa",
        "font-size": "16px"
      }
    })], 1), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "icon-font emkt-icon-shanjian",
      staticStyle: {
        "color": "red",
        "float": "right",
        "font-size": "16px"
      },
      on: {
        "click": function($event) {
          return _vm.removeExperimental(index)
        }
      }
    })]), _vm._v(" "), _c('span', [_c('van-stepper', {
      staticClass: "stepper",
      staticStyle: {
        "float": "right",
        "margin-right": "10%"
      },
      attrs: {
        "min": _vm.currEu === _vm.specialEuTemplateNo(0) ? 0 : 3
      },
      on: {
        "focus": _vm.reSetPageScroll,
        "blur": _vm.reSetPageScroll,
        "overlimit": function($event) {
          _vm.overLimit(_vm.currEu === _vm.specialEuTemplateNo(0) ? 0 : 3)
        },
        "change": function($event) {
          _vm.handleChangeGroupNum(index, _vm.currEu === _vm.specialEuTemplateNo(0) ? 0 : 3)
        }
      },
      model: {
        value: (experimental.number),
        callback: function($$v) {
          _vm.$set(experimental, "number", _vm._n($$v))
        },
        expression: "experimental.number"
      }
    })], 1)])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px 0",
      "margin-top": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.addExperimental()
      }
    }
  }, [_c('span', [_vm._v("增加实验组")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "icon-font emkt-icon-zengjia",
    staticStyle: {
      "color": "#5878fa",
      "float": "right",
      "font-size": "16px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addExperimental()
      }
    }
  })])])], 2)]) : _vm._e(), _vm._v(" "), (!_vm.infectionChecked && !_vm.specialEuTemplateNo().includes(this.currEu)) ? _c('van-cell-group', {
    attrs: {
      "title": "生信分析对照组设置"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0 20px",
      "font-size": "14px"
    }
  }, [_vm._l((_vm.controlGroup), function(controlObject, index) {
    return _c('div', {
      staticStyle: {
        "padding": "20px 0 0 0",
        "text-align": "left"
      }
    }, [_c('span', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (controlObject.experimental),
        expression: "controlObject.experimental"
      }],
      staticClass: "select-group",
      staticStyle: {
        "margin-right": "10px"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(controlObject, "experimental", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "selected": "",
        "value": "0"
      }
    }, [_vm._v("请选择")]), _vm._v(" "), _vm._l((_vm.experimentalGroup), function(item, index) {
      return _c('option', {
        domProps: {
          "value": item
        }
      }, [_vm._v("\n                    " + _vm._s(item.label) + "\n                  ")])
    })], 2), _vm._v(" "), _c('span', [_vm._v("VS")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (controlObject.control),
        expression: "controlObject.control"
      }],
      staticClass: "select-group",
      staticStyle: {
        "margin-left": "10px"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(controlObject, "control", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, _vm.handleChangeExperimentalControl]
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "selected": "",
        "value": "0"
      }
    }, [_vm._v("请选择")]), _vm._v(" "), _vm._l((_vm.experimentalGroup), function(item, index) {
      return _c('option', {
        domProps: {
          "value": item
        }
      }, [_vm._v("\n                    " + _vm._s(item.label) + "\n                  ")])
    })], 2)]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "icon-font emkt-icon-shanjian",
      staticStyle: {
        "color": "red",
        "float": "right",
        "font-size": "16px"
      },
      on: {
        "click": function($event) {
          return _vm.removeControlGroup(index)
        }
      }
    })]), _vm._v(" "), _c('span')])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "15px 0 15px 0",
      "margin-top": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.addControlGroup()
      }
    }
  }, [_c('span', [_vm._v("增加分析对照组")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "icon-font emkt-icon-zengjia",
    staticStyle: {
      "color": "#5878fa",
      "float": "right",
      "font-size": "16px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addControlGroup()
      }
    }
  })])])], 2)]) : _vm._e()], 1)])])], 1) : (_vm.stepNo === 1) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.showProcessTech[0].show) ? _c('div', [_c('van-cell-group', {
    attrs: {
      "title": "样本处理"
    }
  }, [_c('div', {
    staticClass: "g-body"
  }, _vm._l((_vm.sampleProcessTech.ParaRemoveHAProtein), function(item, index) {
    return _c('div', {
      key: index,
      class: (_vm.sampleProcessing.dictKey === item.dictKey || _vm.sampleProcessTech.ParaRemoveHAProtein[index].dictKey === _vm.showProcessTech[0].default) ? 's-self' : 'g-self',
      on: {
        "click": function($event) {
          return _vm.handleSampleProcessChecked(index)
        }
      }
    }, [_c('div', {
      staticClass: "article"
    }, [(item.dictKey === 1) ? _c('div', {
      staticClass: "flag flag-left"
    }, [_vm._v("推荐")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('div', {
      staticClass: "main-title"
    }, [_vm._v("\n                          " + _vm._s(item.dictValue) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "small-title"
    }, [_vm._v(_vm._s(item.extraValue))])])])])
  }), 0)])], 1) : _vm._e(), _vm._v(" "), (_vm.showProcessTech[1].show) ? _c('div', [_c('van-cell-group', {
    attrs: {
      "title": "建库技术"
    }
  }, [_c('div', {
    staticClass: "g-body"
  }, _vm._l((_vm.sampleProcessTech.ParaConstructionTech), function(item, index) {
    return _c('div', {
      key: index,
      class: (_vm.databaseBuildings.dictKey === item.dictKey || _vm.sampleProcessTech.ParaConstructionTech[index].dictKey === _vm.showProcessTech[1].default) ? 's-self' : 'g-self',
      on: {
        "click": function($event) {
          return _vm.handleDatabaseBuildingChecked(index)
        }
      }
    }, [_c('div', {
      staticClass: "article"
    }, [(item.dictKey === 6) ? _c('div', {
      staticClass: "flag flag-left"
    }, [_vm._v("推荐")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('div', {
      staticClass: "main-title"
    }, [_vm._v("\n                          " + _vm._s(item.dictValue) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "small-title"
    }, [_vm._v(_vm._s(item.extraValue))])])])])
  }), 0)])], 1) : _vm._e(), _vm._v(" "), (_vm.showProcessTech[2].show) ? _c('div', [_c('div', [_c('span', {
    staticStyle: {
      "position": "relative",
      "top": "15px",
      "float": "right",
      "right": "20px",
      "font-size": "14px",
      "color": "#5878fa"
    },
    on: {
      "click": _vm.openPdfList
    }
  }, [_vm._v("查看示例报告")]), _vm._v(" "), _c('van-cell-group', {
    attrs: {
      "title": "生信分析"
    }
  }, [_c('div', {
    staticClass: "g-body"
  }, _vm._l((_vm.sampleProcessTech.ParaBioAnalysis), function(item, index) {
    return _c('div', {
      key: index,
      class: (_vm.boSignalAnalysis.dictKey === item.dictKey || _vm.sampleProcessTech.ParaBioAnalysis[index].dictKey === _vm.showProcessTech[2].default) ? 's-self' : 'g-self',
      on: {
        "click": function($event) {
          return _vm.handleBoSignalAnalysisChecked(index)
        }
      }
    }, [_c('div', {
      staticClass: "article"
    }, [(item.dictKey === 1) ? _c('div', {
      staticClass: "flag flag-left"
    }, [_vm._v("免费")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('div', {
      staticClass: "main-title"
    }, [_vm._v("\n                            " + _vm._s(item.dictValue) + "\n                          ")]), _vm._v(" "), _c('div', {
      staticClass: "small-title"
    }, [_vm._v(_vm._s(item.extraValue))])])])])
  }), 0)])], 1)]) : _vm._e(), _vm._v(" "), (_vm.currEu === _vm.specialEuTemplateNo(1)) ? _c('div', [_c('van-cell-group', {
    attrs: {
      "title": "选择基因"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0 20px",
      "font-size": "14px"
    }
  }, [_vm._l((_vm.geneSelectionGroup), function(item, index) {
    return _c('div', {
      staticStyle: {
        "padding": "20px 0"
      }
    }, [_c('span', {
      staticStyle: {
        "margin-right": "5%"
      }
    }, [_vm._v("基因" + _vm._s(index + 1))]), _vm._v(" "), _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.label),
        expression: "item.label"
      }],
      staticStyle: {
        "width": "70%"
      },
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": (item.label)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "label", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "icon-font emkt-icon-shanjian",
      staticStyle: {
        "color": "red",
        "float": "right",
        "font-size": "16px",
        "padding-top": "5px"
      },
      on: {
        "click": function($event) {
          return _vm.removeGeneSearchResult(index)
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "open-popup open-goods",
    staticStyle: {
      "padding": "20px 0"
    },
    attrs: {
      "data-popup": ".popup-gene-only",
      "readonly": "",
      "unselectable": "on"
    }
  }, [_c('span', [_vm._v("添加基因")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "icon-font emkt-icon-zengjia",
    staticStyle: {
      "color": "#5878fa",
      "float": "right",
      "font-size": "16px"
    }
  })])])], 2)])], 1) : _vm._e()])]) : (_vm.stepNo === 2) ? _c('div', [_c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("样本信息")]), _vm._v(" "), _c('div', {
    staticClass: "cell-group-wrap"
  }, [_c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("样本物种")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.sampleSpec))])], 1)], 1), _vm._v(" "), _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("疾病方向")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.diseaseDirectionName))])], 1)], 1), _vm._v(" "), (_vm.productInfo.eu1 !== _vm.specialEuTemplateNo(0)) ? _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("样本分类")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.sampleCategory.label))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("样本类型")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.sampleType))])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("实验分组及样本数")]), _vm._v(" "), _c('div', {
    staticClass: "cell-group-wrap"
  }, [_vm._l((_vm.experimentalGroup), function(experimental, index) {
    return _c('van-cell', {
      key: index
    }, [_c('van-row', [_c('van-col', {
      staticClass: "cell-label",
      attrs: {
        "span": "6"
      }
    }, [_vm._v(_vm._s(experimental.label))]), _vm._v(" "), _c('van-col', {
      staticClass: "cell-content",
      attrs: {
        "span": "18"
      }
    }, [_vm._v(_vm._s(experimental.number))])], 1)], 1)
  }), _vm._v(" "), _vm._l((_vm.controlGroup), function(item, index) {
    return _c('van-cell', {
      key: index
    }, [_c('van-row', [_c('van-col', {
      staticClass: "cell-label",
      attrs: {
        "span": "6"
      }
    }, [_vm._v("生信分析组" + _vm._s(index + 1))]), _vm._v(" "), _c('van-col', {
      staticClass: "cell-content",
      attrs: {
        "span": "18"
      }
    }, [_vm._v(_vm._s(item.experimental.label) + " VS " + _vm._s(item.control.label))])], 1)], 1)
  })], 2)]), _vm._v(" "), ((_vm.currEu !== _vm.specialEuTemplateNo(0) && _vm.currEu !== _vm.specialEuTemplateNo(1))) ? _c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("其他参数")]), _vm._v(" "), _c('div', {
    staticClass: "cell-group-wrap"
  }, [(_vm.showProcessTech[0].show) ? _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("样本处理")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.sampleProcessing.dictValue))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showProcessTech[1].show) ? _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("建库技术")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.databaseBuildings.dictValue))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showProcessTech[2].show) ? _c('van-cell', [_c('van-row', [_c('van-col', {
    staticClass: "cell-label",
    attrs: {
      "span": "6"
    }
  }, [_vm._v("生信分析")]), _vm._v(" "), _c('van-col', {
    staticClass: "cell-content",
    attrs: {
      "span": "18"
    }
  }, [_vm._v(_vm._s(_vm.boSignalAnalysis.dictValue))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.geneSelectionGroup.length > 0) ? _c('div', _vm._l((_vm.geneSelectionGroup), function(item, index) {
    return _c('van-cell', {
      key: index
    }, [_c('van-row', [_c('van-col', {
      staticClass: "cell-label",
      attrs: {
        "span": "6"
      }
    }, [_vm._v("基因" + _vm._s(index + 1))]), _vm._v(" "), _c('van-col', {
      staticClass: "cell-content",
      attrs: {
        "span": "18"
      }
    }, [_vm._v(_vm._s(item.label))])], 1)], 1)
  }), 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("质量承诺")]), _vm._v(" "), _vm._l((_vm.serviceWorkDaysSolution.qualityCommitment), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cell-group-wrap",
      staticStyle: {
        "font-size": "12px",
        "padding": "0 20px"
      }
    }, [_c('div', [_vm._v(_vm._s(index + 1) + "、" + _vm._s(item.nameList[0]))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "segment-wrap"
  }, [_c('span', {
    staticClass: "group-title"
  }, [_vm._v("服务说明")]), _vm._v(" "), _vm._l((_vm.serviceWorkDaysSolution.serviceComments), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cell-group-wrap",
      staticStyle: {
        "font-size": "12px",
        "padding": "0 20px"
      }
    }, [_c('div', [_vm._v(_vm._s(index + 1) + "、" + _vm._s(item.nameList[0]))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])
  })], 2)]) : _vm._e(), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (!_vm.detail) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "top": "90vh",
      "width": "100%",
      "height": "10vh",
      "background": "white"
    }
  }, [(_vm.stepNo < 2) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('van-button', {
    staticClass: "bottom-button",
    staticStyle: {
      "color": "#5878fa",
      "height": "35px"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('van-button', {
    staticClass: "bottom-button",
    class: _vm.bizValidateMsg === '' ? 'next-button-active' : 'next-button-inactive',
    attrs: {
      "disabled": _vm.infectionChecked
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("下一步")])], 1) : _c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "100%",
      "padding": "10px 5px 0 10px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px",
      "float": "left",
      "width": "10%"
    },
    on: {
      "click": _vm.jumpToCart
    }
  }, [(_vm.shoppingCartProductNumber !== 0) ? _c('van-badge', {
    staticClass: "badgev",
    staticStyle: {
      "float": "right",
      "margin": "0 2px 0 0",
      "position": "relative",
      "top": "-8px"
    },
    attrs: {
      "content": _vm.shoppingCartProductNumber
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cart",
    staticStyle: {
      "width": "28px",
      "height": "28px"
    }
  })], 1), _vm._v(" "), _c('van-button', {
    staticClass: "bottom-button-small",
    staticStyle: {
      "color": "#5878fa",
      "height": "35px"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('van-button', {
    staticClass: "bottom-button-small",
    staticStyle: {
      "background": "#5878fa",
      "color": "white",
      "height": "35px"
    },
    on: {
      "click": _vm.gotoCart
    }
  }, [_vm._v(_vm._s(_vm.text))])], 1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "#D2D2D6",
      "text-align": "center",
      "pointer-events": "none"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-bottom": "50%"
    }
  }, [_vm._v("---我是有底线的---")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17b2f1f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_fc/BoSolution/BoSolution.vue
// module id = 1550
// module chunks = 8